// Mirrors handleApiErr's 401 flow in helpers/globalUtils.js — skip while on a skipRouteNames route, log the server-side
// session out first, and redirect to Login regardless of whether the logout call itself succeeds.
export function unauthorizedPolicy({ router, axios, skipRouteNames = ['Login', 'ChangePassword'] }) {
    return {
        appliesTo: (error) => error.statusCode === 401,
        skipNotify: () => true,
        postProcess: () => {
            const currentRouteName = router.currentRoute.value.name;
            if (typeof currentRouteName === 'string' && skipRouteNames.includes(currentRouteName))
                return;
            axios
                .post('/session/logout')
                .catch(() => { })
                .finally(() => {
                router.push({ name: 'Login' }).catch(() => { });
            });
        },
    };
}
